import React, { useEffect, useState } from "react";
import { Table, Button, Title, Group, Text, Paper, Badge, ActionIcon } from "@mantine/core";
import { IconTrash, IconStarFilled } from "@tabler/icons-react";
import { fetchReviews, deleteReview } from "../../api";
import { toast } from "react-toastify";

const Reviews = () => {
    const [reviews, setReviews] = useState([]);

    useEffect(() => {
        loadReviews();
    }, []);

    const loadReviews = async () => {
        try {
            const { data } = await fetchReviews();
            setReviews(data);
        } catch (error) {
            toast.error("Failed to load reviews");
        }
    };

    const handleDelete = async (id) => {
        if (!window.confirm("Are you sure you want to delete this review?")) return;
        try {
            await deleteReview(id);
            toast.success("Review deleted");
            loadReviews();
        } catch (error) {
            toast.error("Failed to delete review");
        }
    };

    const toggleFeature = async (id) => {
        try {
            await fetch(`https://backend.cdp3d.com/reviews/${id}/feature`, {
                method: 'PUT'
            });
            toast.success("Review updated");
            loadReviews();
        } catch (error) {
            toast.error("Failed to update review");
        }
    };

    const rows = reviews.map((review) => (
        <tr key={review._id} style={{ backgroundColor: review.isFeatured ? 'rgba(255, 215, 0, 0.1)' : 'transparent' }}>
            <td>{review.productId?.title || 'Unknown Product'}</td>
            <td>{review.user}</td>
            <td>{review.phoneNumber}</td>
            <td>{review.title}</td>
            <td>
                <Group spacing={4}>
                    {review.rating} <IconStarFilled size={12} color="#fcc419" />
                </Group>
            </td>
            <td><Text size="sm" lineClamp={2}>{review.comment}</Text></td>
            <td>{new Date(review.createdAt).toLocaleDateString()}</td>
            <td>
                <Group spacing="xs">
                    <Button 
                        size="xs" 
                        variant={review.isFeatured ? "filled" : "outline"} 
                        color={review.isFeatured ? "yellow" : "gray"}
                        onClick={() => toggleFeature(review._id)}
                    >
                        {review.isFeatured ? "Unfeature" : "Feature"}
                    </Button>
                    <ActionIcon color="red" variant="subtle" onClick={() => handleDelete(review._id)}>
                        <IconTrash size={16} />
                    </ActionIcon>
                </Group>
            </td>
        </tr>
    ));

    return (
        <div className="content-wrapper">
            <section className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1>Product Reviews</h1>
                        </div>
                    </div>
                </div>
            </section>
            <section className="content">
                <Paper p="md" shadow="sm">
                    <Table highlightOnHover>
                        <thead>
                            <tr>
                                <th>Product</th>
                                <th>User</th>
                                <th>Phone</th>
                                <th>Title</th>
                                <th>Rating</th>
                                <th>Comment</th>
                                <th>Date</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {rows}
                        </tbody>
                    </Table>
                    {reviews.length === 0 && <Text align="center" mt="md">No reviews found.</Text>}
                </Paper>
            </section>
        </div>
    );
};

export default Reviews;
